import dxpDigitalDataAssignment from '../../../../../common/utilities/dxpDigitalDataAssignment';
import { DxpDataLayerEvent, DxpDataLayerEventNames } from '../../../../../common/utilities/customDatalayerInterface';
import { formatDataLayerDeal } from '../utils/dxpDataLayerHandler';
import { GetDeal_deal } from '../graphql/queries/__generated__/GetDeal';

const useCallDxpDigitalAssignmentEntryEvent = () => {
  const callDxpDigitalAssignmentEntryEvent = (deal: GetDeal_deal) => {
    try {
      dxpDigitalDataAssignment({
        event: DxpDataLayerEvent.CONFIGURATOR,
        eventName: DxpDataLayerEventNames.CONFIGURATOR_ENTRY,
        ...formatDataLayerDeal(deal),
      });
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('DataLayer error', err);
    }
  };

  return { callDxpDigitalAssignmentEntryEvent };
};

export default useCallDxpDigitalAssignmentEntryEvent;
